<mat-toolbar class="subtitulo">Cadastro Atividade</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">
        <mat-tab-group>

            <!-- DADOS ATIVIDADE -->
            <mat-tab label="ATIVIDADE">
                <div ngModelGroup="dadosAtividade">
                    <dados-atividade [atividade]=oficina
                                     [perfilAcesso]="perfilAcesso"></dados-atividade>
                </div>
            </mat-tab>

            <!-- Ações -->
            <mat-tab label="AÇÕES">
                <div ngModelGroup="acoesAtividade">
                    <acoes-oficina [oficina]="oficina"
                                   [perfilAcesso]="perfilAcesso"></acoes-oficina>
                </div>
            </mat-tab>

            <!-- DADOS COLABORADORES ATIVIDADE -->
            <mat-tab label="COLABORADORES">
                <div ngModelGroup="colaboradoresAtividade">
                    <colaboradores-atividade [oficina]="oficina"></colaboradores-atividade>
                </div>
            </mat-tab>

            <!-- MATERIAIS DA ATIVIDADE -->
            <mat-tab label="MATERIAIS">
                <div ngModelGroup="materiaisAtividade">
                    <materiais-oficina [oficina]="oficina"></materiais-oficina>
                </div>
            </mat-tab>

        </mat-tab-group>
    </form>


    <!-- BOTOES -->
    <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
        </button>

        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
            color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
            Atualizar
        </button>

        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
            Limpar
        </button>
        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
            Cancelar
        </button>
    </div>
</div>